




import { Component, Vue } from "vue-property-decorator";
import Admin from "@/components/Admin.vue"; // @ is an alias to /src

@Component({
  components: {
    Admin
  }
})
export default class AdminPage extends Vue {}
